import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun ProjectsSection() {
    Section({
        id("Project")
        style {
            padding(32.px)
            backgroundColor(Color("#f5f5f5"))
        }
    }) {
        H2 { Text("Projects") }
        Div({
            style {
                display(DisplayStyle.Flex)
                flexWrap(FlexWrap.Wrap)
                justifyContent(JustifyContent.SpaceEvenly)
            }
        }) {
            ProjectCard(
                title = "Expense Tracker",
                description = "An Android app to track daily expenses, built with Jetpack Compose and Room."
            )
            ProjectCard(
                title = "Weather App",
                description = "A weather forecasting app using Retrofit and MVVM."
            )
            ProjectCard(
                title = "Chat App",
                description = "A real-time chat app using Firebase."
            )
        }
    }
}

@Composable
fun ProjectCard(title: String, description: String) {
    Div({
        style {
            width(30.percent)
            padding(16.px)
            margin(16.px)
            backgroundColor(Color.white)
            //boxShadow(Color.gray, offsetX = 0.px, offsetY = 4.px, blurRadius = 8.px)
        }
    }) {
        H3 { Text(title) }
        P { Text(description) }
    }
}
